import { createAxiosInstance, guid } from '../utils/helpers'
import { API_URL } from './index'
import * as types from './types'
import { displayMessages, uploadFiles, showHideModalDelete } from './common'
import { toast } from 'react-toastify';

export function getMaestras(page=1) {
    return (dispatch) => {
        const axios = createAxiosInstance()
        axios.get(`${API_URL}/maestras`).then(res => {
            dispatch({
                type: types.OBTENER_MAESTRAS,
                payload: res.data
            })
        }).catch(err => {
            displayMessages(dispatch, err)
        })
    }
}

export function toggleSelectItem(item, checked) {
    return {
        type: types.CONMUTAR_SELECCION_MAESTRAS,
        payload: {
            index: item,
            checked
        }
    }
}

export function toggleSelectAllItems(checked) {
    return {
        type: types.CONMUTAR_SELECCION_TODAS_MAESTRAS,
        payload: {
            checked
        }
    }
}

export function showHideModalAddMaestra(show) {
    return {
        type: types.MOSTRAR_MODAL_ADICIONAR_MAESTRA,
        payload: show
    }
}

export function showBarProgress(show) {
    return {
        type: types.MOSTRAR_MODAL_PROGRESS,
        payload: show
    }
}

export function deleteMaestras() {
    return (dispatch, getState) => {
        const maestas_ids = getState().maestras.get('maestras').filter(m => m.get('checked')).map(m => m.get('id'))
        const axios = createAxiosInstance()
        axios({
            method: 'DELETE',
            url: `${API_URL}/maestras`,
            data: {
                maestras: maestas_ids.toJS()
            }
        }).then(res => {
            toast.success("Se han eliminado las maestras correctamente", {bodyClassName:"toastify-content toastify-success"})
            dispatch(getMaestras())
        }).catch(err => {
            displayMessages(dispatch, err)
        }).finally(() => dispatch(showHideModalDelete(false)))
    }
}

export function updateInputs(path, value) {
	return (dispatch, getState) => {
		const fn0 = (d) => d({ type: types.MODIFICAR_INPUTS_MAESTRA, payload: { path, value } })
		fn0(dispatch);
	}
}

export function selectFile(file) {
	return (dispatch) => {
		let icon = '_blank.png';	
        dispatch({ type: types.MODIFICAR_INPUTS_MAESTRA, payload: { path: 'modalAddMaestra.data.nombre', value: file.name } })
        dispatch({ type: types.MODIFICAR_INPUTS_MAESTRA, payload: { path: 'modalAddMaestra.data.file', value: file, immutable: false } })
        dispatch({ type: types.MODIFICAR_INPUTS_MAESTRA, payload: { path: 'modalAddMaestra.data.icono', value: icon } })
        dispatch({ type: types.MODIFICAR_INPUTS_MAESTRA, payload: { path: 'modalAddMaestra.data.guid', value: guid() } })
	}
}

export function AddMaestra() {
    return (dispatch, getState) => {
        const data = getState().maestras.getIn(['modalAddMaestra', 'data'])
        dispatch(uploadFiles('/maestras', [data], [
            () => dispatch(getMaestras()),
            () => toast.success("Se ha actualizado la maestra correctamente", {bodyClassName:"toastify-content toastify-success"})
        ]))
    }
}



export function getProveedores() {
	const axios = createAxiosInstance()
	return (dispatch) => {
        const fn0 = (d) => d({ type: types.MOSTRAR_MODAL_PROGRESS, payload: true })
        const fn1 = (d) => d({ type: types.MOSTRAR_MODAL_PROGRESS, payload: false })
        fn0(dispatch)
		axios.get(`${API_URL}/integracion/proveedores`)
		.then((res) => {
            fn1(dispatch)
            displayMessages(dispatch, { success: res.data.success })
		})
		.catch((err) => {
            fn1(dispatch)
			displayMessages(dispatch, err)
		})
	}
}

export function synchroUsers() {
	const axios = createAxiosInstance()
	return (dispatch) => {
        displayMessages(dispatch, { info: "La sincronización de los usuarios se hará el día de hoy a las 8:00P.M. con el último archivo cargado." })
	}
}


export function getItems() {
	const axios = createAxiosInstance()
	return (dispatch) => {
        const fn0 = (d) => d({ type: types.MOSTRAR_MODAL_PROGRESS, payload: true })
        const fn1 = (d) => d({ type: types.MOSTRAR_MODAL_PROGRESS, payload: false })
        fn0(dispatch)
		axios.get(`${API_URL}/integracion/items`)
		.then((res) => {
            fn1(dispatch)
            displayMessages(dispatch, { success: res.data.success })
		})
		.catch((err) => {
            fn1(dispatch)
			displayMessages(dispatch, err)
		})
	}
}



export function getCencos() {
	const axios = createAxiosInstance()
	return (dispatch) => {
        const fn0 = (d) => d({ type: types.MOSTRAR_MODAL_PROGRESS, payload: true })
        const fn1 = (d) => d({ type: types.MOSTRAR_MODAL_PROGRESS, payload: false })
        fn0(dispatch)
		axios.get(`${API_URL}/integracion/cencos`)
		.then((res) => {
            fn1(dispatch)
            displayMessages(dispatch, { success: res.data.success })
		})
		.catch((err) => {
            fn1(dispatch)
			displayMessages(dispatch, err)
		})
	}
}


// WEBPACK FOOTER //
// ./src/actions/maestra.js